export default __webpack_public_path__ + "static/media/medium-risk-gauge-image.3a59c390.png";